<template>
  <div id="home">
    <div class="top">
      <div class="left">
        <div class="title">效果反馈</div>
        <div class="center">
          <div style="height:65%;border-bottom: 0.5px solid #ccc">
            <div
              style="color: #fff;height: 40%;font-size: 20px;line-height: 94px;padding-left: 4%;width: 155px;"
            >今日进件</div>
            <div
              style="color: #fff;height: 40%;font-size: 65px;line-height: 99px;padding-left: 4%;width: 155px;text-align:center"
            >{{topData.left.tdTotal}}</div>
          </div>
          <div style="height:35%;justify-content: space-around;color:#fff;font-size:20px;">
            <div style="width:33%;text-align:center;float:left;height:100%">
              <div style="height:50%;line-height: 50px;">昨日进件</div>
              <div style="height:50%;line-height: 40px;">{{topData.left.ytdTotal}}</div>
            </div>
            <div style="width:33%;text-align:center;float:left;height:100%">
              <div style="height:50%;line-height: 50px;">本月进件</div>
              <div style="height:50%;line-height: 40px;">{{topData.left.tmTotal}}</div>
            </div>
            <div style="width:33%;text-align:center;float:left;height:100%">
              <div style="height:50%;line-height: 50px;">总进件</div>
              <div style="height:50%;line-height: 40px;">{{topData.left.total}}</div>
            </div>
          </div>
          <img src="../assets/imgs/blue.png" />
        </div>
      </div>
      <div class="right">
        <div class="title"></div>
        <div class="center">
          <div style="height:65%;border-bottom: 0.5px solid #ccc">
            <div
              style="color: #fff;height: 40%;font-size: 20px;line-height: 94px;padding-left: 4%;width: 155px;"
            >今日结算</div>
            <div
              style="color: #fff;height: 40%;font-size: 65px;line-height: 99px;padding-left: 4%;width: 155px;text-align:center"
            >{{topData.right.toDayRewardTotal/100}}</div>
          </div>
          <div style="height:35%;justify-content: space-around;color:#fff;font-size:20px;">
            <div style="width:33%;text-align:center;float:left;height:100%">
              <div style="height:50%;line-height: 50px;">昨日结算</div>
              <div style="height:50%;line-height: 40px;">{{topData.right.yesterDayRewardTotal/100}}</div>
            </div>
            <div style="width:33%;text-align:center;float:left;height:100%">
              <div style="height:50%;line-height: 50px;">本月结算</div>
              <div style="height:50%;line-height: 40px;">{{topData.right.thisMonthRewardTotal/100}}</div>
            </div>
            <div style="width:33%;text-align:center;float:left;height:100%">
              <div style="height:50%;line-height: 50px;">总结算</div>
              <div style="height:50%;line-height: 40px;">{{topData.right.allRewardTotal/100}}</div>
            </div>
          </div>
          <img src="../assets/imgs/red.png" />
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="left" style="height:100%;width:60%;float:left;border-right: 2px solid #ccc;">
        <div class="title">数据报表</div>
        <div class="select">
          <div @click="ReportForms('今日')" :class="{white: selectLeft=='今日'}">今日</div>
          <div @click="ReportForms('昨日')" :class="{white: selectLeft=='昨日'}">昨日</div>
          <div @click="ReportForms('本月')" :class="{white: selectLeft=='本月'}">本月</div>
          <div @click="ReportForms('上月')" :class="{white: selectLeft=='上月'}">上月</div>
          <div @click="ReportForms('历史')" :class="{white: selectLeft=='历史'}">历史</div>
        </div>
        <div style="width:100%;height:78%" id="drawPie"></div>
      </div>
      <div class="right" style="height:100%;width:40%;float:left">
        <div class="title">团队成员排行</div>
        <div class="select">
          <div @click="rank('今日')" :class="{white: selectright=='今日'}">今日</div>
          <div @click="rank('昨日')" :class="{white: selectright=='昨日'}">昨日</div>
          <div @click="rank('本月')" :class="{white: selectright=='本月'}">本月</div>
          <div @click="rank('上月')" :class="{white: selectright=='上月'}">上月</div>
          <div @click="rank('历史')" :class="{white: selectright=='历史'}">历史</div>
        </div>
        <div style="width:100%;height:78%" id="drawPillar"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "../biz/api";
import echarts from "echarts";
export default {
  name: "home",
  data() {
    return {
      topData: {
        left: {},
        right: {}
      },
      myChartPie: {},
      selectLeft: "今日",
      selectright: "今日",
      optionPie: {},
      myChartPillar: {},
      optionPillar: {}
    };
  },
  mounted: function() {
    this.getTopData();
    this.drawPie();
    this.drawPillar();
    this.ReportForms("今日");
    this.myChartPillar.setOption(this.optionPillar);
  },
  activated: function() {
    this.getTopData();
    this.drawPie();
    this.drawPillar();
    this.ReportForms("今日");
    this.myChartPillar.setOption(this.optionPillar);
  },

  methods: {
    getTopData() {
      api.GetRewardTotal().then(res => {
        this.topData.right = res.body.data;
      });
      api.GetInformationTotalv2().then(res => {
        this.topData.left = res.body.data;
      });
    },
    assignmentLeft(res) {
      this.optionPie.series[0].data = [];
      this.optionPie.legend.data = [];

      if (res.body.data) {
        res.body.data.forEach(element => {
          this.optionPie.series[0].data.push({
            value: element.total,
            name: element.productName
          });
          this.optionPie.legend.data.push(element.productName);
        });
      }
      this.myChartPie.setOption(this.optionPie);
    },
    ReportForms(type) {
      this.selectLeft = type;
      if (type === "今日") {
        api.StatisticsDate(1).then(res => {
          this.assignmentLeft(res);
        });
      }
      if (type === "昨日") {
        api.StatisticsDate(2).then(res => {
          this.assignmentLeft(res);
        });
      }
      if (type === "本月") {
        api.StatisticsDate(3).then(res => {
          this.assignmentLeft(res);
        });
      }
      if (type === "上月") {
        api.StatisticsDate(4).then(res => {
          this.assignmentLeft(res);
        });
      }
      if (type === "历史") {
        api.StatisticsDate(0).then(res => {
          this.assignmentLeft(res);
        });
      }
    },
    rank(type) {
      this.selectright = type;
      if (type === "今日") {
        api.StatisticsRankList(1).then(res => {
          this.assignmentRight(res);
        });
      }
      if (type === "昨日") {
        api.StatisticsRankList(2).then(res => {
          this.assignmentRight(res);
        });
      }
      if (type === "本月") {
        api.StatisticsRankList(3).then(res => {
          this.assignmentRight(res);
        });
      }
      if (type === "上月") {
        api.StatisticsRankList(4).then(res => {
          this.assignmentRight(res);
        });
      }
      if (type === "历史") {
        api.StatisticsRankList(0).then(res => {
          this.assignmentRight(res);
        });
      }
    },
    assignmentRight(res) {
      this.optionPillar.series[0].data = [];
      this.optionPillar.yAxis[0].data = [];
      this.optionPillar.yAxis[1].data = [];
      if (res.body.data) {
        res.body.data.reverse();
        res.body.data.forEach(element => {
          this.optionPillar.series[0].data.push({
            value: element.total,
            name: element.username
          });
          this.optionPillar.yAxis[0].data.push(element.username);
          this.optionPillar.yAxis[1].data.push(element.total);
        });
      }
      this.myChartPillar.setOption(this.optionPillar);
    },
    drawPie() {
      this.myChartPie = echarts.init(document.getElementById("drawPie"));
      this.optionPie = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          right: "100",
          data: []
        },
        series: [
          {
            name: "报表比例",
            type: "pie",
            radius: "80%",
            label: {
              show: false
            },
            center: ["40%", "50%"],
            data: [],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      };
    },
    drawPillar() {
      this.myChartPillar = echarts.init(document.getElementById("drawPillar"));
      this.optionPillar = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c}（单）"
        },
        legend: {
          show: false
        },

        xAxis: {
          show: false,
          type: "value",
          boundaryGap: [0, 0.01]
        },
        yAxis: [
          {
            type: "category",
            name: "姓名",
            nameTextStyle: {
              color: "#57a3f3"
            },
            splitLine: { show: false },
            axisLine: { show: false },
            axisTick: { show: false },
            data: []
          },
          {
            type: "category",
            name: "进件",
            nameTextStyle: {
              color: "#57a3f3"
            },
            splitLine: { show: false },
            axisLine: { show: false },
            axisTick: { show: false },
            data: []
          }
        ],
        series: [
          {
            name: "订单排行",
            type: "bar",
            itemStyle: { barBorderRadius: 8 },
            data: [],
            barWidth: 8
          }
        ]
      };
    }
  }
};

// GetRewardTotal
</script>

<style scoped>
#home {
  height: 100%;
}
.top {
  height: 45%;
}
.top .left {
  width: 50%;
  height: 100%;
  float: left;
}

.white {
  background: #fff;
  color: black !important;
}
.top .left .center {
  position: relative;
  width: 90%;
  height: 70%;
  background-image: linear-gradient(
    to right,
    rgb(24, 63, 139),
    rgb(84, 117, 184)
  );
  margin-left: 40px;
  border-radius: 15px;
}
.top .right .center {
  position: relative;
  width: 90%;
  height: 70%;
  background-image: linear-gradient(
    to right,
    rgb(96, 59, 138),
    rgb(207, 51, 71)
  );
  margin-left: 40px;
  border-radius: 15px;
}
.top .center img {
  position: absolute;
  right: 5%;
  top: 10%;
}
.top .left .title {
  height: 20%;
  width: 100%;
  color: black;
  line-height: 75px;
  padding-left: 40px;
  font-size: 20px;
  font-weight: 900;
}
.top .right .title {
  height: 20%;
  width: 100%;
}
.top .right {
  float: right;
  width: 50%;
  height: 100%;
}
.bottom {
  border-top: 2px solid #ccc;
  height: 55%;
}
.bottom .title {
  height: 15%;
  width: 100%;
  color: black;
  line-height: 75px;
  padding-left: 40px;
  font-size: 20px;
  font-weight: 900;
}
.bottom .select {
  margin-left: 40px;
  height: 30px;
  width: 60%;
  background: #20222a;
  padding: 3px;
  display: flex;
  justify-content: space-around;
  border-radius: 3px;
}
.bottom .select div {
  float: left;
  height: 100%;
  width: 20%;
  color: #fff;
  line-height: 25px;
  text-align: center;
  border-radius: 3px;
}
</style>